module.exports = "<h2>Tasks:</h2>\n<park-task-form [parkId]=\"parkId\" [id]=\"id\" [mode]=\"'create'\"></park-task-form>\n\n<div class=\"filter\">\n  <h3>Filter by status</h3>\n  <park-filter (change)=\"setFilter($event)\" [filters]=\"filters\"></park-filter>\n</div>\n\n<park-tasks-item *ngFor=\"let key of objectKeys(filteredTasks())\" [taskId]=\"key\" [id]=\"id\"\n                 [task]=\"filteredTasks()[key]\" [parkId]=\"parkId\"></park-tasks-item>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/tasks/park-tasks.html
// module id = ./src/app/dashboard/parks/park/tasks/park-tasks.html
// module chunks = main